import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { NewTypeOperationCrubs } from 'practice/constants/type-operation-crubs';
import FormTypeOperation, { FormTypeOperationVM } from 'practice/components/type-operation/form';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { AxiosPromise } from 'axios';
import { toast } from 'react-toastify';

const NewTypeOperation = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-tipo-operazione');
  });

  const insertTypeOperation = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/tipo-operazione/`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormTypeOperationVM) => {
      const dataInsert = insertTypeOperation({
        data: {
          descrizioneBreveTipoOperazione: values.descriptionBrief || undefined,
          descrizioneTipoOperazione: values.description || undefined,
          codiceTipoDocumento: values.typeDocument || undefined,
          flagStampaDocumento: values.printDoc || undefined,
          codiceMotivo: values.codeMovement || null,
          flagOperazioneInUso: values.inUse || undefined,
          key: {
            tipoPratica: values.practice,
            tipoOperazione: values.code,
          },
        },
      }) as AxiosPromise;
      dataInsert.then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-tipo-operazione');
      });
    },
    [insertTypeOperation, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={NewTypeOperationCrubs} />
      <FormTypeOperation title="Nuovo Tipo Operazione" onCancel={onCancel} onSubmit={onSubmit} />
    </Fragment>
  );
};

NewTypeOperation.displayName = 'New Type Practice Page component';

export default NewTypeOperation;
